import React, { useEffect, useState } from "react";
import  { useNavigate, Navigate } from 'react-router-dom'
import { baseUrl } from "../shared";
import '../pages/App.css';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { Toggle } from './ui';

export function Register({ onClose, onSuccess }) {
    const [usernameReg, setUsernameReg] = useState("");
    const [passwordReg, setPasswordReg] = useState ("");
    // No default: the Select below is controlled and starts on a disabled
    // placeholder, so a company must be actively chosen. (Previously this
    // defaulted to '1MAINT' with an UNCONTROLLED Select: the browser displayed
    // the first company in the list while the state silently kept '1MAINT',
    // so untouched dropdowns registered users under the wrong company.)
    const [companyReg, setCompanyReg] = useState ("");
    const [nameReg, setNameReg] = useState ("");
    const [emailReg, setEmailReg] = useState ("");
    const [phoneReg, setPhoneReg] = useState ("");
    const [canSearchReg, setCanSearchReg] = useState ("0");
    const [canAddAssetReg, setCanAddAssetReg] = useState ("0");
    const [canEditAssetReg, setCanEditAssetReg] = useState ("0");
    const [canDeleteAssetReg, setCanDeleteAssetReg] = useState ("0");
    const [canInspectAssetReg, setCanInspectAssetReg] = useState ("0");
    const [canAddAttachmentReg, setCanAddAttachmentReg] = useState ("0");
    const [canRegisterUserReg, setCanRegisterUserReg] = useState ("0");
    const [canUpdateUserReg, setCanUpdateUserReg] = useState ("0");
    const [canBulkAddReg, setCanBulkAddReg] = useState ("0");
    const [canAddDefect, setCanAddDefect] = useState ("0");
    const [canViewPlatformDashboard, setCanViewPlatformDashboard] = useState ("0");
    const [canViewSchedule, setCanViewSchedule] = useState ("0");
    const [canManageSchedule, setCanManageSchedule] = useState ("0");
    const [canManageWorkshop, setCanManageWorkshop] = useState ("0");
    const [canViewWorkshopHistory, setCanViewWorkshopHistory] = useState ("0");
    const [canUseDetailedInspection, setCanUseDetailedInspection] = useState ("0");
    const [canAdminReport, setCanAdminReport] = useState ("0");
    var [companies, setCompanies] = useState([]);
    const [companiesLoaded, setCompaniesLoaded] = useState(false);
    const navigate = useNavigate();
    
    const [loginStatus, setLoginStatus] = useState(false);
    const [createNewUser] = useState(true);
    const [open, setOpen] = React.useState(false);
    const [errOpen, setErrOpen] = React.useState(false);
    const [message, setMessage] = useState('');

    const handleClose = () => {
      setOpen(false);
      <Navigate to={'/admin/'} />
      {navigate(0)}
    };

    const handleErrClose = () => {
      setErrOpen(false);
    };

    useEffect(()=> {
      if (!localStorage.getItem('token')) {
        setLoginStatus(false);
      } else {
        setLoginStatus(true);
      }
    },[]);

    useEffect(() => {
      if (companiesLoaded === false ) {
      const url = baseUrl + 'company/list/';
        fetch(url, {
          method: 'GET',
          headers: {
              'username': localStorage.getItem('username'),
              'bToken': localStorage.getItem('bToken')
          }})
          .then((res) => {
            return res.json();
        }).then((json) => {
            console.log(json)
            setCompanies(json);
            setCompaniesLoaded(true);
        })
        .catch((err) => {
           console.log(err.message);
        });
      }
      })   

  const cancelCreateUser = () => {
    if (onClose) { onClose(); return; }
    <Navigate to={'/admin/'} />
    {navigate(0)}
  };
  
  const sendCreateUser = async () => {
    if (!companyReg) {
      setMessage('Please select a company before creating the user.');
      setErrOpen(true);
      return;
    }
    const url = baseUrl+"user/register";
    var payload = {
      "userName": usernameReg,
      "password": passwordReg,
      "name": nameReg,
      "company": companyReg,
      "email": emailReg,
      "phone": phoneReg,
      "active": 1,
      "canSearch": Number(canSearchReg),
      "canAddAsset": Number(canAddAssetReg),
      "canEditAsset": Number(canEditAssetReg),
      "canDeleteAsset": Number(canDeleteAssetReg),
      "canInspectAsset": Number(canInspectAssetReg),
      "canAddAttachment": Number(canAddAttachmentReg),
      "canRegisterUser": Number(canRegisterUserReg),
      "canUpdateUser": Number(canUpdateUserReg),
      "canBulkAdd": Number(canBulkAddReg),
      "canAddDefect": Number(canAddDefect),
      "canViewPlatformDashboard": Number(canViewPlatformDashboard),
      "canViewSchedule": Number(canViewSchedule),
      "canManageSchedule": Number(canManageSchedule),
      "canManageWorkshop": Number(canManageWorkshop),
      "canViewWorkshopHistory": Number(canViewWorkshopHistory),
      "canUseDetailedInspection": Number(canUseDetailedInspection),
      "canAdminReport": Number(canAdminReport),
    }
    await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'username': localStorage.getItem('username'),
            'bToken': localStorage.getItem('bToken')
        },
        body: ( "json", JSON.stringify( payload ) )
      })
      .then((response) => response.json())
        .then((data) => {
          console.log(data)
          if( data.status === 200) {
          setMessage(data.message);
          setOpen(true);
          } else if (data.status === 401) {
            setMessage(data.message);
            setErrOpen(true);
          }
        })
        .catch((err) => {
          setMessage(err.message);
          setOpen(true);
        });
};

  
    return (
      <>
        <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="confirmDeleteTitle">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="confirmDeleteDesc">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
        <React.Fragment>
      <Dialog
        open={errOpen}
        onClose={handleErrClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="addAccountError">
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="addAccountDesc">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleErrClose}>Ok</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
    

    { loginStatus && createNewUser && localStorage.getItem('canRegisterUser') === '1' ? (
        <form className="registration" style={{ display: 'flex', flexDirection: 'column', maxHeight: '82vh', margin: 0, width: '100%' }}>
          <Box sx={{ flexShrink: 0, px: 3, py: 1.5, borderBottom: '1px solid var(--border)', background: 'var(--surface)' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: 'var(--text)' }}>Register New User</Typography>
          </Box>
          <Box sx={{ flex: 1, overflowY: 'auto', px: 3, py: 2 }}>
        <Box>
         <TextField 
        fullWidth
        required
          margin="dense"
          id="username" 
          label="Username" 
          variant="outlined" 
          type="text"  
          onChange={(e) => {
            setUsernameReg(e.target.value);
          }}
        />
     </Box>
        <Box>
         <TextField 
        fullWidth
        required
          margin="dense"
          id="password" 
          label="Password" 
          variant="outlined" 
          type="password"  
          onChange={(e) => {
            setPasswordReg(e.target.value);
          }}
        />
     </Box>
     <FormControl
          margin="dense"
     fullWidth>
     <InputLabel shrink htmlFor="companyTitle">
    Company *
  </InputLabel>
        <Select
          native
          required
          label="Company   *"
          inputProps={{
            id: 'companyTitle',
          }}
          fullWidth
          value={companyReg}
          onChange={(e) => {
            setCompanyReg(e.target.value);
          }}>
          <option value="" disabled>Select a company</option>
          {
          companies.map((companies) => {
          return <option value={companies.company} key={companies.company}>{companies.description}</option>
        })
      }
  </Select>
     </FormControl>
        <Box>
         <TextField 
        fullWidth
        required
          margin="dense"
          id="name" 
          label="Name" 
          variant="outlined" 
          type="text"  
          onChange={(e) => {
            setNameReg(e.target.value);
          }}
        />
     </Box>
        <Box>
         <TextField 
        fullWidth
        required
          margin="dense"
          id="email" 
          label="E-Mail Address" 
          variant="outlined" 
          type="text"  
          onChange={(e) => {
            setEmailReg(e.target.value);
          }}
        />
     </Box>
        <Box>
         <TextField 
        fullWidth
        required
          margin="dense"
          id="phone" 
          label="Phone Number" 
          variant="outlined" 
          type="text"  
          onChange={(e) => {
            setPhoneReg(e.target.value);
          }}
        />
     </Box>
     <Box sx={{ width: '100%', border: '1px solid var(--border)', borderRadius: 1, mt: 1, mb: 1 }}>
       {[
         { label: 'Can Use Asset Search',        checked: canSearchReg === "1",            setter: setCanSearchReg },
         { label: 'Can Add Defects',              checked: canAddDefect === "1",             setter: setCanAddDefect },
         { label: 'Can Create New Assets',        checked: canAddAssetReg === "1",           setter: setCanAddAssetReg },
         { label: 'Can Edit Existing Assets',     checked: canEditAssetReg === "1",          setter: setCanEditAssetReg },
         { label: 'Can Delete Existing Assets',   checked: canDeleteAssetReg === "1",        setter: setCanDeleteAssetReg },
         { label: 'Can Inspect Assets',           checked: canInspectAssetReg === "1",       setter: setCanInspectAssetReg },
         { label: 'Can Add Attachments',          checked: canAddAttachmentReg === "1",      setter: setCanAddAttachmentReg },
         { label: 'Can Create New Users',         checked: canRegisterUserReg === "1",       setter: setCanRegisterUserReg },
         { label: 'Can Edit/Update Users',        checked: canUpdateUserReg === "1",         setter: setCanUpdateUserReg },
         { label: 'Can Bulk Upload',              checked: canBulkAddReg === "1",            setter: setCanBulkAddReg },
         { label: 'Can View Reports',             checked: canViewPlatformDashboard === "1", setter: setCanViewPlatformDashboard },
         { label: 'Can View Admin Reports',       checked: canAdminReport === "1",           setter: setCanAdminReport },
         { label: 'Can View Schedule',            checked: canViewSchedule === "1",          setter: setCanViewSchedule },
         { label: 'Can Manage Schedule',          checked: canManageSchedule === "1",        setter: setCanManageSchedule },
         { label: 'Can Manage Workshop',          checked: canManageWorkshop === "1",        setter: setCanManageWorkshop },
         { label: 'Can View Workshop History',    checked: canViewWorkshopHistory === "1",   setter: setCanViewWorkshopHistory },
         { label: 'Can Use Detailed Inspection',  checked: canUseDetailedInspection === "1", setter: setCanUseDetailedInspection },
       ].map(({ label, checked, setter }, i, arr) => (
         <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, py: 0.75, backgroundColor: i % 2 === 0 ? 'var(--surface-2)' : 'var(--surface)', borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none' }}>
           <Box component="span" sx={{ fontSize: '0.875rem', color: 'var(--text)', flex: 1 }}>{label}</Box>
           <Toggle checked={checked === true || checked === "1"} onChange={() => setter(checked ? "0" : "1")} />
         </Box>
       ))}
     </Box>
          </Box>{/* end scrollable middle */}
          <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1.5, px: 3, py: 1.5, borderTop: '1px solid var(--border)', background: 'var(--surface)' }}>
            <Button variant="outlined" color="inherit" sx={{ color: 'var(--muted)', borderColor: 'var(--border-strong)' }} onClick={cancelCreateUser}>Cancel</Button>
            <Button variant="contained" onClick={sendCreateUser}>Register</Button>
          </Box>
        </form>
        ) : null
      }
      </>
    );
  }

export default Register